/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_No_Company_Assigned_TitleInputs */

const en_company_no_company_assigned_title = /** @type {(inputs: Company_No_Company_Assigned_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No company assigned`)
};

const de_company_no_company_assigned_title = /** @type {(inputs: Company_No_Company_Assigned_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Unternehmen zugeordnet`)
};

/**
* | output |
* | --- |
* | "No company assigned" |
*
* @param {Company_No_Company_Assigned_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_no_company_assigned_title = /** @type {((inputs?: Company_No_Company_Assigned_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_No_Company_Assigned_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_no_company_assigned_title(inputs)
	return en_company_no_company_assigned_title(inputs)
});